var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.612061,
    y: 0.611816,
    width: 54.8829,
    height: 54.8829,
    rx: 4,
    fill: "#E83E8C",
    fillOpacity: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 18H20.6C20.0399 18 19.7599 18 19.546 18.109C19.3578 18.2049 19.2049 18.3578 19.109 18.546C19 18.7599 19 19.0399 19 19.6V23.4C19 23.9601 19 24.2401 19.109 24.454C19.2049 24.6422 19.3578 24.7951 19.546 24.891C19.7599 25 20.0399 25 20.6 25H24.4C24.9601 25 25.2401 25 25.454 24.891C25.6422 24.7951 25.7951 24.6422 25.891 24.454C26 24.2401 26 23.9601 26 23.4V19.6C26 19.0399 26 18.7599 25.891 18.546C25.7951 18.3578 25.6422 18.2049 25.454 18.109C25.2401 18 24.9601 18 24.4 18Z",
    stroke: "#E83E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 18H31.6C31.0399 18 30.7599 18 30.546 18.109C30.3578 18.2049 30.2049 18.3578 30.109 18.546C30 18.7599 30 19.0399 30 19.6V23.4C30 23.9601 30 24.2401 30.109 24.454C30.2049 24.6422 30.3578 24.7951 30.546 24.891C30.7599 25 31.0399 25 31.6 25H35.4C35.9601 25 36.2401 25 36.454 24.891C36.6422 24.7951 36.7951 24.6422 36.891 24.454C37 24.2401 37 23.9601 37 23.4V19.6C37 19.0399 37 18.7599 36.891 18.546C36.7951 18.3578 36.6422 18.2049 36.454 18.109C36.2401 18 35.9601 18 35.4 18Z",
    stroke: "#E83E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 29H31.6C31.0399 29 30.7599 29 30.546 29.109C30.3578 29.2049 30.2049 29.3578 30.109 29.546C30 29.7599 30 30.0399 30 30.6V34.4C30 34.9601 30 35.2401 30.109 35.454C30.2049 35.6422 30.3578 35.7951 30.546 35.891C30.7599 36 31.0399 36 31.6 36H35.4C35.9601 36 36.2401 36 36.454 35.891C36.6422 35.7951 36.7951 35.6422 36.891 35.454C37 35.2401 37 34.9601 37 34.4V30.6C37 30.0399 37 29.7599 36.891 29.546C36.7951 29.3578 36.6422 29.2049 36.454 29.109C36.2401 29 35.9601 29 35.4 29Z",
    stroke: "#E83E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 29H20.6C20.0399 29 19.7599 29 19.546 29.109C19.3578 29.2049 19.2049 29.3578 19.109 29.546C19 29.7599 19 30.0399 19 30.6V34.4C19 34.9601 19 35.2401 19.109 35.454C19.2049 35.6422 19.3578 35.7951 19.546 35.891C19.7599 36 20.0399 36 20.6 36H24.4C24.9601 36 25.2401 36 25.454 35.891C25.6422 35.7951 25.7951 35.6422 25.891 35.454C26 35.2401 26 34.9601 26 34.4V30.6C26 30.0399 26 29.7599 25.891 29.546C25.7951 29.3578 25.6422 29.2049 25.454 29.109C25.2401 29 24.9601 29 24.4 29Z",
    stroke: "#E83E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.1e8db14cff07ae83b951b9580f428837.svg";
export { ForwardRef as ReactComponent };